import React, { useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useExpanded, useTable } from "react-table";
import { Button, Checkbox, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import HomeIcon from '@material-ui/icons/Home';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import { Link } from "react-router-dom";

import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Menu } from "@material-ui/icons";

const IsDraggingContext = React.createContext(false);

const useStyle = makeStyles({
  itemStatus: {
    color: "#306F9D",
    "&.archive": {
      color: "#962013",
    },
  },
  buttonGroup: {
    textAlign: "left",
    marginTop: "20px",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  draggableTableRow: {
    "&.isDragging": {
      boxShadow: "0px 2px 10px 5px #ccc",
    },
  },
});


const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

function formatData(content) {
  const formattedData = content.map((row) => {
    return {
      id: row.id,
      enTitle: row.localizations?.en?.title,
      tcTitle: row.localizations?.tc?.title,
      visibility: row.status.status,
      mainPage: row.isHeader,
    };
  });
  return formattedData;
}

function CustomTableCell(props) {
  return (
    <TableCell
      style={{
        paddingTop: 6,
        paddingBottom: 6,
        lineHeight: "1.1em",
        height: "48px",
      }}
      align={props.align}
      className={props.className}
    >
      {props.children}
    </TableCell>
  );
}

class DraggableTableCell extends React.Component {
  getSnapshotBeforeUpdate(prevProps) {
    if (!this.ref) {
      return null;
    }

    const isDragStarting =
      this.props.isDragOccurring && !prevProps.isDragOccurring;

    if (!isDragStarting) {
      return null;
    }

    const { width, height } = this.ref.getBoundingClientRect();

    const snapshot = {
      width,
      height,
    };

    return snapshot;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const ref = this.ref;
    if (!ref) {
      return;
    }

    if (snapshot) {
      if (ref.style.width === snapshot.width) {
        return;
      }
      ref.style.width = `${snapshot.width}px`;
      ref.style.height = `${snapshot.height}px`;
      return;
    }

    if (this.props.isDragOccurring) {
      return;
    }

    // inline styles not applied
    if (ref.style.width == null) {
      return;
    }

    // no snapshot and drag is finished - clear the inline styles
    ref.style.removeProperty("height");
    ref.style.removeProperty("width");
  }

  setRef = (ref) => {
    this.ref = ref;
  };

  render() {
    return (
      <TableCell
        style={{
          paddingTop: 6,
          paddingBottom: 6,
          lineHeight: "1.1em",
          height: "48px",
        }}
        ref={this.setRef}
        align={this.props.align}
      >
        {this.props.children}
      </TableCell>
    );
  }
}

const VisibilityCheckbox = ({ index, defaultField, control, classes, data }) => {
  return defaultField ? (
    <Controller
      control={control}
      name={`menu.${index}.visibility`}
      render={({ field: { value, onChange, ...rest }, fieldState }) => {
        return (
          // <VisibilityIcon fontSize="small" style={{ color: "#BCBCBC" }} />
          <Checkbox
            className="VisibilityCheckbox"
            checked={defaultField.visibility}
            icon={<VisibilityOffIcon style={{ color: "#CCCCCC" }}/>}
            checkedIcon={<VisibilityIcon style={{ color: "#306F9D" }}/>}
            onChange={(e) => {
              updateVisibilityCheckbox(e.target.checked,index,data);
              onChange(e.target.checked);
            }}
            {...rest}
          />
        );
      }}
    />
  ) : null;
};

function updateVisibilityCheckbox(checked,index,data){
  console.log(checked);
  console.log(data);
  data = data.map((v, i) => {
    if(i == index){
      v.visibility = checked;
    }
    return v;
  })
}

function updateMainpageCheckbox(index,data){
  console.log(data);
  data = data.map((v, i) => {
    if(i == index){
      v.mainPage = 1;
    }else{
      v.mainPage = 0;
    }
    return v;
  })
  var elements = document.querySelectorAll(".mainPageCheckbox input");
  elements.forEach(element => {
    console.log(element.checked);
    if(element.checked){
      element.click();
    }
  });
  var element = document.querySelector('input[name="menu['+index+'].mainPage"]');
  element.click();
  
}

const MainPageCheckbox = ({ index, defaultField, control, data }) => {
  return (
    <Controller
      control={control}
      name={`menu[${index}].mainPage`}
      render={({ field: { value, onChange, ...rest }, fieldState }) => {
        return (
          <Checkbox
            className="mainPageCheckbox"
            color="primary"
            checked={!!defaultField && defaultField.mainPage}
            icon={<HomeOutlinedIcon style={{ color: "#CCCCCC" }}/>}
            checkedIcon={<HomeIcon style={{ color: "#306F9D" }}/>}
            onChange={(e) => {
              updateMainpageCheckbox(index,data);
              onChange(e.target.checked);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

function CustomTableRow(props) {
  const { row, className, index, control, field, provided, snapshot, classes, data } = props;
  return (
    <IsDraggingContext.Consumer>
      {(isDragging) => (
        <TableRow
          style={{ background: "white" }}
          className={`${className} ${snapshot.isDragging ? "isDragging" : ""}`}
          key={`customRow-${index}`}
          ref={provided.innerRef}
          isDragging={snapshot.isDragging}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <DraggableTableCell isDragOccurring={isDragging} scope="row">
            <Link
              to={`/hkiff-app/menu/edit/${row.original.id}`}
              style={{ textDecoration: "none", color: "#306F9D" }}
            >
              {row.cells[0].render("Cell")}
            </Link>
          </DraggableTableCell>
          <DraggableTableCell
            isDragOccurring={isDragging}
            align="left"
            style={{ color: "#306F9D" }}
          >
            {row.cells[1].render("Cell")}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging}>
            {row.cells[2].render("Cell")}
            {/* <VisibilityCheckbox
              defaultField={field}
              index={index}
              control={control}
              classes={classes}
              data={data}
            /> */}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging}>
            {row.cells[3].render("Cell")}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging} align="left">
            {row.cells[4].render("Cell")}
          </DraggableTableCell>
        </TableRow>
      )}
    </IsDraggingContext.Consumer>
  );
}

export default function MenuTable({ disabled, ...props }) {
  const classes = useStyle();
  const { setLoading } = useLoading();
  const [data, setData] = React.useState([]);
  const [defaultValues, setDefaultValues] = React.useState({ menu: [] });
  const [isDragging, setIsDragging] = React.useState(false);

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    reset,
    setValue,
    formState,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control,
      name: "menu",
    }
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "Title (English)",
        accessor: "enTitle",
      },
      {
        Header: "Title (Traditional)",
        accessor: "tcTitle",
      },
      {
        Header: "Visibility",
        accessor: "visibility",
        Cell: ({ row }) => {
          return (
            <VisibilityCheckbox
              defaultField={data[row.index]}
              index={row.index}
              control={control}
              data={data}
            />
          );
        },
      },
      {
        Header: "Main Page",
        accessor: "mainpage",
        Cell: ({ row }) => {
          return (
            <MainPageCheckbox
              defaultField={data[row.index]}
              index={row.index}
              control={control}
              data={data}
            />
          );
        },
      },
      {
        Header: "",
        id: "icon",
        Cell: () => {
          return <Menu fontSize="small" style={{ color: "#CCCCCC" }} />;
        },
      },
    ],
    [control, data]
  );

  const defaultExpandedRows = [];
  for (let index = 0; index < 10; index++) {
    defaultExpandedRows.push({ index: true });
  }

  const { getTableProps, headerGroups, rows, prepareRow, toggleRowExpanded } =
    useTable(
      {
        columns,
        data,
        initialState: {
          pageIndex: 0,
          expanded: defaultExpandedRows,
        },
      },
      useExpanded
    );

  const getMenu = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiffApp.getHkiffAppMenu();
      const processedData = formatData(result.data);
      setData(processedData);
      setDefaultValues({ menu: processedData });
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }, [setLoading]);

  const updateMenuOrder = async (data) => {
    try {
      const result = await apiHelper.hkiffApp.updateHkiffAppMenuOrder(data);
      if (result.status === 200) {
        toast.dark("Your changes is saved.");
        getMenu();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const formatRequestData = (values) => {
    return {
      menuSequences: values
        .map((value, index) => {
          let seq = [
            {
              id: value.id,
              sequence: index,
              isHeader: value.mainPage ? 1 : 0,
              deleted: false,
              status: value.visibility
            }
          ];
          return seq;
        })
        .flat()
    };
  };

  const onSubmit = (values) => {
    const requestData = formatRequestData(data);
    console.log(requestData);
    updateMenuOrder(requestData);
  };

  const onBeforeCapture = (beforeCapture) => {
    toggleRowExpanded(beforeCapture.draggableId, false);
  };

  const onBeforeDragStart = () => {
    setIsDragging(true);
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(data, result.source.index, result.destination.index);
    setData(items);
    toggleRowExpanded(result.destination.index, true);
  };

  useEffect(() => {
    getMenu();
  }, [getMenu]);

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Menu
      </Typography>
      <IsDraggingContext.Provider value={isDragging}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset disabled={disabled} className="fieldset">
            <Paper>
              <Table aria-label="simple table" {...getTableProps()}>
                <TableHead component="div">
                  {headerGroups.map((headerGroup) => (
                    <TableRow {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <TableCell
                          {...column.getHeaderProps()}
                          style={{
                            paddingTop: 6,
                            paddingBottom: 6,
                            lineHeight: "1.1em",
                            height: "48px",
                          }}
                        >
                          {column.render("Header")}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableHead>
                <DragDropContext
                  onBeforeDragStart={onBeforeDragStart}
                  onDragEnd={onDragEnd}
                  onBeforeCapture={onBeforeCapture}
                >
                  <Droppable droppableId="parentMenu" type="MENU">
                    {(provided, snapshot) => (
                      <TableBody
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {defaultValues.menu.length > 0 &&
                          rows.map((row, index) => {
                            prepareRow(row);
                            const rowProps = row.getRowProps();
                            return (
                              <>
                                <Draggable
                                  key={row.id}
                                  draggableId={row.id}
                                  index={index}
                                  isDragDisabled={disabled}
                                >
                                  {(provided, snapshot) => (
                                    <CustomTableRow
                                      className={classes.draggableTableRow}
                                      key={`parentRow-${row.id}`}
                                      row={row}
                                      index={index}
                                      control={control}
                                      field={fields[`${index}`]}
                                      provided={provided}
                                      snapshot={snapshot}
                                      classes={classes}
                                      data={data}
                                    />
                                  )}
                                </Draggable>
                              </>
                            );
                          })}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
              </Table>
            </Paper>
            {disabled || (
              <div className={classes.buttonGroup}>
                <Button
                  type="submit"
                  variant="contained"
                  disableElevation
                  style={{
                    color: "white",
                    background: "#306F9D",
                    marginRight: "5px",
                    padding: "9px 16px",
                  }}
                >
                  Save Changes
                </Button>
              </div>
            )}
          </fieldset>
        </form>
      </IsDraggingContext.Provider>
    </>
  );
}
